import styled from "styled-components";
import { Breakpoint } from "../../../enums/Breakpoints";

export const Title = styled.div`
  font-family: ${({ theme }) => theme.redesign.heavyFont};
  line-height: 100%;
  margin-bottom: 10px;
  font-size: 28px;

  @media ${Breakpoint.MinTablet} {
    margin-bottom: 5px;
    font-size: 32px;
  }
`;

export const Text = styled.div`
  font-size: 14px;
  line-height: 18px;

  @media ${Breakpoint.MinTablet} {
    font-size: 18px;
    line-height: 22px;
  }
`;

export const SmallText = styled.div`
  font-size: 12px;
  line-height: 12px;
`;

export const BoundHeavyText = styled.div`
  font-size: 22px;
  line-height: 22px;
  font-family: ${({ theme }) => theme.redesign.heavyFont};
`;

export const BoundRegularText = styled.div`
  font-size: 14px;
  line-height: 14px;
`;
